export default "__VITE_ASSET__BGnxTkZn__"